import getPageName from "./getPageName";

const site = () => {
  changeDate("February, 16");
  seeAllFaq();
  seeAllProgramm();
  reviewsContent();
  headerMenu();
  advCaceProgram();

  // Collapse blocks
  collapseList(
    ".barriers-list",
    ".barriers-list__item-head",
    ".barriers-list__item-collapse",
    ".barriers-list__item-icon"
  );
  collapseList(
    ".faq__blocks",
    ".faqBlock__top",
    ".faqBlock__collapse",
    ".faqBlock__icon"
  );

  if (window.innerWidth <= 800) {
    collapseList(
      ".footer-item__list--1",
      ".footer-item__list-head",
      ".footer-item__list-collapse",
      ".footer-item__list-icon"
    );
    collapseList(
      ".footer-item__list--2",
      ".footer-item__list-head",
      ".footer-item__list-collapse",
      ".footer-item__list-icon"
    );
    collapseList(
      ".program__blocks",
      ".programBlock__top",
      ".programBlock__right",
      ".programBlock__icon"
    );
  }

  if (window.innerWidth < 768) {
    collapseList(
      ".careerNew__blocks",
      ".careerNew-block__button",
      ".careerNew-block__p",
      ".careerNew-block__button-icon"
    );
    collapseList(
      ".requirements__blocks",
      ".requirements__button",
      ".requirements-block__p",
      ".requirements__button-icon"
    );
  }

  // Смена дат
  function changeDate(date) {
    const dates = document.querySelectorAll(".change-date");

    if (dates.length > 0) {
      dates.forEach((item) => {
        item.innerHTML = date;
      });
    }
  }

  //Кнопки смотреть все
  function seeAllFaq() {
    let btn_viewAll = document.querySelector(".faqBlock__button");
    let blocks = document.querySelectorAll(".faq__block");

    blocks.forEach((item, index) => {
      blocks[index].style.height = 0;
      blocks[index].style.border = "none";

      for (var i = 0; i < 5; i++) {
        blocks[i].removeAttribute("style");
      }

      btn_viewAll?.addEventListener("click", function () {
        if (blocks[index].hasAttribute("style")) {
          blocks[index].removeAttribute("style");

          btn_viewAll.textContent = "Collapse all";

          btn_viewAll.classList.add("active");
        } else {
          blocks[index].style.display = "none";

          for (var i = 0; i < 5; i++) {
            blocks[i].removeAttribute("style");
          }

          blocks[0].scrollIntoView();

          btn_viewAll.textContent = "Show all questions";

          btn_viewAll.classList.remove("active");
        }
      });
    });
  }

  // Плавный скролл
  function setNavigation() {
    $("a[href^='#']:not(.employment-formats__btn):not([rel='modal:open'])").on(
      "click",
      function (e) {
        e.preventDefault();
        $("html,body")
          .stop()
          .animate(
            {
              scrollTop: $(`#${this.href.split("#").pop()}`).offset().top,
            },
            700
          );
      }
    );
  }

  $(function () {
    setNavigation();
  });

  // Добавление контента в блок "Отзывы наших выпускников"
  function reviewsContent() {
    const pageName = getPageName(),
      reviewsBlocks = document.querySelector(".reviews__blocks");

    function parseReviews() {
      $.ajax({
        type: "GET",
        url: "/files/reviews.json",
      }).then(function (blocks) {
        blocks.forEach(function (el) {
          if (reviewsBlocks) {
            if (el.url == pageName) {
              createReviewsBlock(el.data);
            }
          }
        });
      });
    }

    function createReviewsBlock(data) {
      let content = '';

      data.forEach((item) => {
        content += `
                <div class="reviews-block swiper-slide" style="background:url('${item.img}') no-repeat center">
                    <p class="reviews-block__name">${item.name}</p>
                    <p class="reviews-block__description">${item.content}</p>
                    <p class="reviews-block__program">${item.program}
                </div>
            `;
      });

      reviewsBlocks.innerHTML = content;

      setTimeout(() => {
        setSwiper(".reviews-swiper", "reviews");
      }, 50);
    }

    parseReviews();
  }

  // Collapse
  function collapseList(wrapper, btns, collapse, icon) {
    let wrap = document.querySelector(wrapper);

    if (wrap) {
      let buttons = wrap.querySelectorAll(btns),
        blockCollapseHeights = [],
        collapseBlock = wrap?.querySelectorAll(collapse);

      buttons.forEach((item, i) => {
        if (collapseBlock[i]) {
          blockCollapseHeights.push(collapseBlock[i].clientHeight);
          collapseBlock[i].style.height = 0;

          item.addEventListener("click", (e) => {
            e.stopImmediatePropagation();

            if (collapseBlock[i].style.height == 0 + "px") {
              collapseBlock[i].style.height = blockCollapseHeights[i] + "px";
              item.querySelector(icon).classList.add("rotate");
            } else {
              collapseBlock[i].style.height = 0;
              item.querySelector(icon).classList.remove("rotate");
            }
          });
        }
      });
    }
  }

  //Кнопки смотреть все
  function seeAllProgramm() {
    let btn_viewAll = document.querySelector(".program__button"),
      blocks = document.querySelectorAll(".program__block"),
      heightToThirdEl =
        blocks[0]
          ?.querySelector(".programBlock__list")
          .childNodes[5]?.getBoundingClientRect().bottom -
        blocks[0]?.querySelector(".programBlock__list").getBoundingClientRect()
          .top;
    let quantity = blocks.length;

    if (!btn_viewAll) return;
    blocks.forEach((item, index) => {
      blocks[index].style.height = "0";

      for (var i = 0; i < 2; i++) {
        blocks[i].removeAttribute("style");

        if (window.innerWidth > 767) {
          blocks[i].style.height = heightToThirdEl + 36 + "px";
        }
      }

      if (index >= 2 && index <= quantity) {
        item.style.borderTop = "none";
      }

      btn_viewAll.addEventListener("click", function () {
        if (blocks[index].hasAttribute("style")) {
          blocks[index].removeAttribute("style");

          btn_viewAll.textContent = "Collapse all";

          btn_viewAll.classList.add("active");
        } else {
          blocks[index].style.display = "none";
          for (var i = 0; i < 2; i++) {
            blocks[i].removeAttribute("style");

            if (window.innerWidth >= 767) {
              blocks[i].style.height = heightToThirdEl + 36 + "px";
            }
          }

          if (window.innerWidth > 767) {
            blocks[0].style.borderBottom = "1px solid #1f1f1f";
          }

          blocks[0].scrollIntoView({
            behavior: "smooth",
          });

          btn_viewAll.textContent = "Show the program";

          btn_viewAll.classList.remove("active");
        }
      });
    });
  }

  //Хэдэр-меню
  function headerMenu() {
    let button_1 = document.querySelector(".header__item_top"),
      button_2 = document.querySelector(".header-hamburger"),
      body = document.querySelector("body"),
      home = document.querySelector(".home"),
      catalog = document.querySelector(".catalog"),
      menu = document.querySelector(".popup-header");

    button_1?.addEventListener("mouseover", () => {
      menu.classList.add("popup-header-active");
      document.querySelector(".header__item_top-icon").classList.add("active");

      home?.addEventListener("mouseover", () => {
        menu.classList.remove("popup-header-active");
        document
          .querySelector(".header__item_top-icon")
          .classList.remove("active");
      });

      catalog?.addEventListener("mouseover", () => {
        menu.classList.remove("popup-header-active");
        document
          .querySelector(".header__item_top-icon")
          .classList.remove("active");
      });
    });

    button_2?.addEventListener("click", () => {
      if (button_2.classList.contains("header-hamburger-active")) {
        button_2.classList.remove("header-hamburger-active");
        menu.classList.remove("popup-header-active");
        body.style.overflow = "visible";
      } else {
        menu.classList.add("popup-header-active");
        button_2.classList.add("header-hamburger-active");
        body.style.overflow = "hidden";
      }
    });

    function clickChoose() {
      let buttonsClick = Array.from(
          document.querySelectorAll(".popup-header__list")
        ),
        menuSections = Array.from(
          document.querySelectorAll(".popup-header__program")
        ),
        targetMenu;

      buttonsClick.forEach((item) => {
        item.addEventListener("mouseover", function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();

          buttonsClick.forEach((i) => {
            i.classList.remove("active-list");
          });
          item.classList.toggle("active-list");

          menuSections.forEach((it) => {
            it.classList.remove("program-active");
          });

          targetMenu = menuSections[buttonsClick.indexOf(item)];
          targetMenu.classList.toggle("program-active");
        });
      });
    }
    clickChoose();
  }

  /* Реализация показа/скрытия баннера */
  (() => {
    const banner = document.querySelector("[data-banner]");
    if (!banner) return;
    const header = document.querySelector(".header");
    const form = document.querySelector("#form");

    const trackScroll = () => {
      const scrolled = window.pageYOffset;
      if (scrolled < header.offsetTop + header.clientHeight) {
        banner.style.transform = "translateY(207%)";
      } else if (
        scrolled + document.documentElement.clientHeight >
        form.offsetTop
      ) {
        banner.style.transform = "translateY(207%)";
      } else if (scrolled < form.offsetTop) {
        banner.style.transform = "translateY(0)";
      }
    };
    window.addEventListener("scroll", trackScroll);
  })();

  // Интеграция Adv.Cace для программ
  function advCaceProgram() {
    let targetUrl = location.href.split("/");

    //Включаем на странице программ и передаем имя программы
    if (!targetUrl.includes("program")) {
      return;
    }

    try {
      const programName =
        document?.querySelector("h1").childNodes[0].textContent;

      window.advcake_data = window.advcake_data || [];
      window.advcake_data.push({
        pageType: 2,
        user: {
          email: "",
        },
        currentLead: {
          leadid: "",
          name: programName,
        },
      });
    } catch (e) {
      console.log(e);
    }
  }

  /* Цели метрик для JivoSite */

  // Пользователь отправил сообщение в чат
  function jivo_onClientStartChat() {
    ym(92965313, "reachGoal", "Jivo_Client_initiate_chat");
  }

  // Оператор инициировал диалог с посетителем
  function jivo_onAccept() {
    ym(92965313, "reachGoal", "Jivo_Proactive_invitation_accepted");
  }

  // Пользователь отправил контактные данные в чате
  function jivo_onIntroduction() {
    ym(92965313, "reachGoal", "Jivo_Offline_message_sent");
  }
};

export default site;
